import { render, staticRenderFns } from "./Cancelacion.vue?vue&type=template&id=74e14be1&"
import script from "./Cancelacion.vue?vue&type=script&lang=js&"
export * from "./Cancelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports